import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { RightIcon } from '../../../Icons/rightIcon';
import { PendingFile } from '../../createEscalation.models';
import styles from './pendingFileRow.module.css'

interface PendingFileRowProps {
    file: PendingFile;
    onRemove: (id: string) => void;
}

export const PendingFileRow: React.FC<PendingFileRowProps> = ({ file, onRemove }) => (
    <div className={styles.pendingFileRow} key={file.id}>
        <div className={styles.pendingFileInfo}>
            <div className={styles.iconWithName}>
                <RightIcon width={15} height={15} fillColor="#00A634" />
                <span className={styles.pendingFileName}>{file.name}</span>
            </div>
            <button
                type="button"
                className={styles.pendingFileRemove}
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove(file.id);
                }}
                aria-label={`Remove ${file.name}`}
            >
                <CloseIcon />
            </button>
        </div>
    </div>
);